import toast from "react-hot-toast";
import { QOOHOO_WEBSITE_DOMAIN } from "constants/env";
import httpf from "./api/frontend/httpf";

import useEntityStore from "store/entityStore";
import useAppState from "store/appState";
import usePurchaseState from "store/purchaseState";
import OrderModel from "models/OrderModel";

export default async function createOrder(userExtraData = {}) {
    const entity = useEntityStore.getState().entity;
    const order = useAppState.getState().order;
    const setOrder = useAppState.getState().setOrder;

    try {
      let _payload, payload, res, orderObj;

      if(entity.isOneToOneMeeting) {
        const { email, guest_emails, agenda, ...otherExtraData} = userExtraData;
        
        const meetingData = {
          user_email: email,
          user_display_name: userExtraData.name,
          guest_emails,
          agenda,
        }

        _payload = order.preparePayload(meetingData);
        payload = {
          ..._payload,
          user_extra_data: {
              ...otherExtraData
          }
        }
      } else {
        _payload = order.preparePayload();
          payload = {
            ..._payload,
            user_extra_data: {
                ...userExtraData
            }
          }
      }

      if(entity.data.payment.isFreeToAccess) {
        throw new Error("This channel cannot be joined. Please contact the creator");
        res = await createOrderForFreeSubscription(entity.data.uid);
      } else if(entity.isPremiumContent) {
        throw new Error("This content cannot be purchased. Please contact the creator");
        res = await createOrderForPremiumContent(payload);
      } else if(entity.isOneToOneMeeting) {
        throw new Error("This meeting cannot be scheduled. Please contact the creator");
        res = await createOrderForOneToOneMeeting(entity.data.uid, payload);
      } else if(entity.isRegularChannel || entity.isCourse) {
        throw new Error("This channel cannot be purchased. Please contact the creator");
        res = await createOrderForCourseOrChannel(payload);
      }

      throw new Error("This channel cannot be joined now. Please contact the creator");

      orderObj = res.data;

      return {...orderObj, userExtraData};
    } catch (err) {
      toast.error(err?.message);

      return false;
    }

}

async function createOrderForOneToOneMeeting(uid, payload){
    return httpf.post(`${QOOHOO_WEBSITE_DOMAIN}/api/meeting/book-slot?id=${uid}`, payload, {withCredentials: true})
} 

async function createOrderForPremiumContent(payload) {
    return httpf.post(`${QOOHOO_WEBSITE_DOMAIN}/api/get-order-id`, payload, {withCredentials: true})
}

async function createOrderForCourseOrChannel(payload) {
    return httpf.post(`${QOOHOO_WEBSITE_DOMAIN}/api/get-order-id`, payload, {withCredentials: true});
}

async function createOrderForFreeSubscription(uid) {
    return httpf.post(`${QOOHOO_WEBSITE_DOMAIN}/api/subscribe`, { id: uid }, {withCredentials: true})
}
